<div
    class="container"
    [ngClass]="{ stat: contentType() === 'stat', chart: contentType() === 'chart' }"
    [id]="dashboardCardId() | idGenerator: 'ngx-dashboardCard-'"
>
    @if (tooltip()) {
        <span class="icon" [innerHTML]="icon()" libTooltip [tooltip]="tooltip()" [position]="tooltipPosition()"></span>
    }
    <div class="dashboardCard">
        <ng-content></ng-content>
    </div>
</div>
